import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, ISelectList, IUsersList } from '../../interfaces';

export function useUsersSelect(): ISelectList {
    return useContext(MobXProviderContext).RootStore.usersStore.select;
}

export function useUsersTable(): IUsersList {
    return useContext(MobXProviderContext).RootStore.usersStore.list;
}

export function useUsersFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.usersStore.filterParams;
}
